import {getBootstrapDeviceSize} from "./getBootstrapDeviceSize";


function throttle(func, delay) {
    let timeoutId = null;
    let lastCall = 0;

    return function(...args) {
        const now = Date.now();
        const remaining = delay - (now - lastCall);

        if (remaining <= 0) {
            if (timeoutId) {
                clearTimeout(timeoutId);
                timeoutId = null;
            }
            lastCall = now;
            func.apply(this, args);
        } else if (!timeoutId) {
            timeoutId = setTimeout(() => {
                lastCall = Date.now();
                timeoutId = null;
                func.apply(this, args);
            }, remaining);
        }
    };
}




export const initProjectDetail = () => {

    Alpine.data("projectDetailSubNav", () => ({
            open: false, // Default active tab

            init() {
                this.$watch('open', (value) => {
                    // emit event
                    this.$dispatch('contentopen', {open: value}, true);
                });
            }
        })
    )

    Alpine.data("projectDetailSlider", () => ({
            open: false, // Default active tab

            init() {
                // watch out for event from subnav
                window.addEventListener('contentopen', (e) => {
                    this.open = e.detail.open;
                });
            }
        })
    )

    Alpine.data("projectLightBox", (images) => ({
        images,
        currentIndex: 0,
        showModal: false,
        windowWidth: window.innerWidth,

        openModal(index) {
            this.currentIndex = index;
            this.showModal = true;
        },

        closeModal() {
            this.showModal = false;
        },

        nextImage() {
            this.currentIndex = (this.currentIndex + 1) % this.images.length;
        },

        prevImage() {
            this.currentIndex = (this.currentIndex - 1 + this.images.length) % this.images.length;
        },

        get currentImage() {
            return this.images[this.currentIndex];
        },

        get currentImageSrc(){

            if(!this.windowWidth) return;

            if(false && ["xs","sm"].includes(getBootstrapDeviceSize())){
                return this.images[this.currentIndex].src_mobile;
            }
            return this.images[this.currentIndex].src;
        },

        init() {

            const bgcarousel = document.getElementById('bgcarousel');
            if (bgcarousel) {
                bgcarousel.addEventListener('slid.bs.carousel', (function(e) {
                    // e.to enthält den Index der neuen aktiven Folie
                    const currentIndex = e.to;
                    // Dispatch ein CustomEvent, das den aktuellen Index enthält
                    if(!this.showModal){
                        this.currentIndex = currentIndex;
                    }

                }).bind(this));
            }


            window.addEventListener('open-lightbox', event => {
                this.openModal(this.currentIndex);
            });

            window.addEventListener('resize', () => {
                this.windowWidth = window.innerWidth;
            });

            //this.openModal(this.currentIndex)
        }
    }));



    var default_subnav_height = window.getComputedStyle(document.documentElement).getPropertyValue("--subnav-height").trim();
    var subnavWrapper = document.getElementById("subnavwrapper");

    function checkTwoLinesTitle(){
        if(["xs","sm"].includes(getBootstrapDeviceSize())){
            if(!subnavWrapper) return;
            subnavWrapper.classList.remove("twolines");
            document.documentElement.style.setProperty("--subnav-height", default_subnav_height);
        }

        var title = document.querySelector('.proj-detail-subnav-title');
        if (title) {
            // Computed Style abrufen
            var computedStyle = window.getComputedStyle(title);
            var lineHeightValue = computedStyle.lineHeight;



            // Falls der line-height-Wert "normal" zurückgibt, einen Fallback verwenden:
            var fontSize = parseFloat(computedStyle.fontSize);
            var lineHeight = lineHeightValue === "normal" ? fontSize * 1.2 : parseFloat(lineHeightValue);

            // Höhe des Titels
            var titleHeight = title.offsetHeight;
            // Anzahl der Zeilen schätzen
            var lines = Math.round(titleHeight / lineHeight);

            // Unabhängig von der Zeilenzahl wird hier die aktuelle Höhe des Subnavwrappers gemessen

            if(subnavWrapper){
                var newSubnavHeight = subnavWrapper.offsetHeight;
                if(lines == 1){
                    subnavWrapper.classList.remove("twolines");
                    document.documentElement.style.setProperty("--subnav-height", default_subnav_height);

                }
                if(lines == 2){
                    subnavWrapper.classList.add("twolines");
                    document.documentElement.style.setProperty("--subnav-height", 80 + "px");
                }
                if(lines == 3){
                    subnavWrapper.classList.add("twolines");
                    document.documentElement.style.setProperty("--subnav-height", 120 + "px");
                }
                // Setze die CSS-Variable --subnav-height im :root (document.documentElement)

            }
        }
    }

    checkTwoLinesTitle();
   // window.addEventListener("DOMContentLoaded",checkTwoLinesTitle);
    window.addEventListener("resize", throttle(checkTwoLinesTitle, 100));


}


